class RechargeWidget {
    constructor() {
        this.initObserver();
    }
    initObserver() {
        const observer = new MutationObserver((mutationsList, observer) => {
           this.widgetRadios = document.querySelectorAll(".rc-radio input[type='radio']");
           this.selectedInput = document.querySelector(".rc-radio input[type='radio']:checked");
           this.subscriptionPriceElement = document.querySelector(".rc-widget .subscription-radio .price-label");
           this.onetimePriceElement = document.querySelector(".rc-widget .onetime-radio .price-label");
           this.freDropDown = document.querySelector(".rc-widget .rc-selling-plans-dropdown__select");

           this.btnPriceElement = document.querySelector(".product__info-container .pdp-add-to-cart .product-total-price");
           this.btnComparePriceElement = document.querySelector(".product__info-container .pdp-add-to-cart .product-total-price.compare-price");

            this.selectedVariant = document.querySelector('form#addtocartform [data-selected-variant]')?.innerHTML;
            this.variantJSON = this.selectedVariant ? JSON.parse(this.selectedVariant) : null;


            this.productMetafields = document.querySelector('form#addtocartform [data-product-metafields]')?.innerHTML;
            this.productMetafieldsJSON = this.productMetafields ? JSON.parse(this.productMetafields) : null;

                      
           this.oneTimePrice = this.variantJSON.price;
           this.oneTimeComparePrice = this.variantJSON.compare_at_price;
           this.subsPrice = this.variantJSON.selling_plan_allocations[0].price;
           this.frequencyValue = this.variantJSON.selling_plan_allocations[0].selling_plan_id;
           if(this.freDropDown) this.frequencyValue = this.freDropDown.value;

         
          
           if(this.productMetafieldsJSON.product_discount && this.productMetafieldsJSON.enable_discount) {
              const discountPersentage = Number(this.productMetafieldsJSON.product_discount);
              const temp = (this.oneTimePrice*discountPersentage)/100;
              this.oneTimePrice = this.variantJSON.price-temp;
              this.oneTimeComparePrice = this.variantJSON.price;
           }
           
           if(this.widgetRadios && this.subscriptionPriceElement && this.onetimePriceElement && this.selectedInput) {
               observer.disconnect();
             
               this.updateWidgetPrice();
               this.updateFreDropDown();
             
               this.updateButtonPrice();
               this.widgetRadios.forEach((input)=> {
                   input.addEventListener("change",  (event)=> {
                      this.frequencyValue = this.variantJSON.selling_plan_allocations[0].selling_plan_id;
                      this.selectedInput = input;
                      this.updateFreDropDown();
                      this.updateButtonPrice();
                      this.updateWidgetPrice();
                   });
                });
              
            }
            
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }
    updateFreDropDown() {
      this.freDropDown = document.querySelector(".rc-widget .rc-selling-plans-dropdown__select")?document.querySelector(".rc-widget .rc-selling-plans-dropdown__select"):this.freDropDown;
     
      this.freDropDown?.addEventListener("change",  (event)=> {
          this.frequencyValue = event.target.value;
          this.updateWidgetPrice();
          this.updateButtonPrice();
      });
    }
    updateWidgetPrice() {
        const selectedPlanJson = this.getSelectedSellingPlan(this.frequencyValue);
        this.updatePriceValue(selectedPlanJson);
        
        if(this.subscriptionPriceElement) {
          this.subscriptionPriceElement.innerHTML = `<span>${this.moneyFormat(this.subsPrice)}</span><span class="compare-price">${this.oneTimeComparePrice != null?this.moneyFormat(this.oneTimeComparePrice):this.moneyFormat(this.oneTimePrice)}</span>`;
        }
        if(this.onetimePriceElement) {
          this.onetimePriceElement.innerHTML = `<span>${this.moneyFormat(this.oneTimePrice)}</span><span class="compare-price">${this.oneTimeComparePrice != null?this.moneyFormat(this.oneTimeComparePrice):''}</span>`;
        }
    }
    updateButtonPrice() {

      
         const selectedPlanJson = this.getSelectedSellingPlan(this.frequencyValue);
         this.updatePriceValue(selectedPlanJson);
      
         if(this.selectedInput.value == 'onetime') {
           this.btnPriceElement.innerHTML = this.moneyFormat(this.oneTimePrice);
           this.btnComparePriceElement.innerHTML = this.oneTimeComparePrice != null?this.moneyFormat(this.oneTimeComparePrice):'';
         }
         else {
           this.btnPriceElement.innerHTML = this.moneyFormat(this.subsPrice);
           this.btnComparePriceElement.innerHTML = this.oneTimeComparePrice != null?this.moneyFormat(this.oneTimeComparePrice):this.moneyFormat(this.oneTimePrice);
         }
    }
   
    updatePriceValue(selectedPlanJson) {
      if(!selectedPlanJson) return;
      this.subsPrice = selectedPlanJson.price;
    }
    getSelectedSellingPlan(selling_plan) {
       return this.variantJSON.selling_plan_allocations.find(
            (item) => item.selling_plan_id === Number(selling_plan)
       );
    }
    moneyFormat(cents) {
        var Shopify = Shopify || {};
        let format = "${{amount}}";
       
                  if (typeof cents == 'string') { cents = cents.replace('.',''); }
                  var value = '';
                  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                  var formatString = (format || this.money_format);
                
                  function defaultOption(opt, def) {
                     return (typeof opt == 'undefined' ? def : opt);
                  }
                
                  function formatWithDelimiters(number, precision, thousands, decimal) {
                    precision = defaultOption(precision, 2);
                    thousands = defaultOption(thousands, ',');
                    decimal   = defaultOption(decimal, '.');
                
                    if (isNaN(number) || number == null) { return 0; }
                
                    number = (number/100.0).toFixed(precision);
                
                    var parts   = number.split('.'),
                        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                        cents   = parts[1] ? (decimal + parts[1]) : '';
                
                    return dollars + cents;
                  }
                
                  switch(formatString.match(placeholderRegex)[1]) {
                    case 'amount':
                      value = formatWithDelimiters(cents, 2);
                      break;
                    case 'amount_no_decimals':
                      value = formatWithDelimiters(cents, 0);
                      break;
                    case 'amount_with_comma_separator':
                      value = formatWithDelimiters(cents, 2, '.', ',');
                      break;
                    case 'amount_no_decimals_with_comma_separator':
                      value = formatWithDelimiters(cents, 0, '.', ',');
                      break;
                  }
                
                  return formatString.replace(placeholderRegex, value);
          
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    new RechargeWidget();
  });